import DailyWeather from "../views/DailyWeather";
import HourlyWeather from "../views/HourlyWeather";

export const routes = [
  {
    path: "/daily",
    name: "Daily",
    component: DailyWeather
  },
  {
    path: "/hourly",
    name: "Hourly",
    component: HourlyWeather,
    props: true
  },
  {
    path: "*",
    redirect: { name: "Daily" }
  }
];
